import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "@/lib/api";
import { formatPrice } from "@/lib/utils";
import { Users, MapPin, Calendar, DollarSign, ArrowRight, Sparkles } from "lucide-react";

export default function AdminDashboard() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [stats, setStats] = useState({ users: 0, courts: 0, bookings: 0, revenue: 0 });

  useEffect(() => {
    api.get("/admin/stats").then((r) => setStats(r.data));
  }, []);

  const kpis = [
    { icon: DollarSign, label: t("admin.revenue"), value: formatPrice(stats.revenue, "JOD") },
  ];

  return (
    <div className="min-h-[calc(100vh-64px)] bg-background">
      <div className="max-w-[1400px] mx-auto px-5 md:px-10 py-10">
        <div className="label-eyebrow text-volt mb-2">{t("admin.eyebrow")}</div>
        <h1 className="font-heading text-5xl md:text-6xl tracking-tight mb-10">{t("admin.title")}</h1>

        <div className="grid md:grid-cols-1 gap-1 mb-10 max-w-sm">
          {kpis.map((k) => (
            <div key={k.label} className="border border-border/30 bg-card p-6 flex items-start justify-between">
              <div>
                <div className="label-eyebrow mb-2">{k.label}</div>
                <div className="font-heading text-5xl">{k.value}</div>
              </div>
              <k.icon className="h-5 w-5 text-volt" />
            </div>
          ))}
        </div>

        <div className="grid md:grid-cols-4 gap-1">
          {[
            { to: "/admin/users", icon: Users, label: t("admin.manage_users"), count: stats.users },
            { to: "/admin/bookings", icon: Calendar, label: t("admin.manage_bookings"), count: stats.bookings },
            { to: "/admin/courts", icon: MapPin, label: t("admin.manage_courts"), count: stats.courts },
            { to: "/admin/amenities", icon: Sparkles, label: "Amenities", count: "—" },
          ].map((card) => (
            <button
              key={card.to}
              onClick={() => navigate(card.to)}
              className="border border-border/30 bg-card p-6 text-start hover:bg-muted transition-colors group cursor-pointer"
            >
              <div className="flex items-center justify-between mb-4">
                <card.icon className="h-6 w-6 text-volt" />
                <ArrowRight className="h-4 w-4 text-muted-foreground/40 group-hover:text-muted-foreground transition-colors" />
              </div>
              <div className="label-eyebrow mb-1">{card.label}</div>
              <div className="font-heading text-3xl">{card.count}</div>
            </button>
          ))}
        </div>
      </div>
    </div>
  );
}
